<template>
  <div class="bto-sb-horse-event-content">
    <div class="bto-sb-horse-event-item">
      <div class="bto-sb-horse-event-item-content">
          <div class="bto-sb-horse-event-item-name">
            <span class="bto-sb-horse-racername">{{runner.name}}</span>
          </div>
          <!-- <div class="bto-sb-horse-event-item-stat">
            <a :title="$translate.text('Match.Statistics.Title')"></a>
          </div> -->
          <div class="bto-sb-horse-event-item-odd" v-if="runner.outcomes.length" @click="processOdd(runner,runner.outcomes,status)" >
            <div :class="['bto-sb-event-odd',
                          {
                            'bto-sb-event-odd-active': isOddSelected,
                            'bto-sb-odd-lock': !runner.outcomes[0].isPublished
                          }]">
              <span>{{runner.outcomes[0].outcome || '--'}}</span>
            </div>
          </div>
          <div class="bto-sb-horse-event-item-odd" v-if="!runner.outcomes.length">
            <div class="bto-sb-event-odd">
              <span>{{'--'}}</span>
            </div>
          </div>
      </div>
    </div>
  </div>  
</template>

<script>
  import HrRaceOdds from './hr-race-odds';
  export default {
    extends: HrRaceOdds,
    name: 'AntepostRaceOdds'
  };
</script>